import api from './api';

export interface CreateCheckoutSessionRequest {
  eventId: number;
  numberOfTickets: number;
}

export interface CreateCheckoutSessionResponse {
  sessionId: string;
  url: string;
}

export const createCheckoutSession = async (
  data: CreateCheckoutSessionRequest
): Promise<CreateCheckoutSessionResponse> => {
  try {
    const response = await api.post<CreateCheckoutSessionResponse>('/payments/create-checkout-session', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  createCheckoutSession,
};

